/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_Qa as Qa,
  rec_React as React,
  rec_api as api,
} from "../../runtime/index.jsx";
export function ImagenActa({ actaId: e, archivo: t, alto: n = `h-20` }) {
  let [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(0);
  return (
    (0, React.useEffect)(() => {
      let n = !0,
        r,
        a = `/inspecciones/${e}/archivos/${t.id}`;
      async function s() {
        try {
          let e = await api(`${a}/enlace`, {
              sinCache: !0,
            }),
            t = e.remoto ? e.url : await Qa(a);
          (e.remoto || (r = t),
            n ? (i(t), o(``)) : r && URL.revokeObjectURL(r));
        } catch (e) {
          n && o(e.message);
        }
      }
      return (
        s(),
        () => {
          ((n = !1), r && URL.revokeObjectURL(r));
        }
      );
    }, [e, t.id, s]),
    a ? (
      <AccionAsync
        variante={`secundario`}
        className={`min-h-11 text-xs`}
        onClick={() => c(s + 1)}
        children={`Volver a cargar`}
      />
    ) : r ? (
      <a
        href={r}
        target={`_blank`}
        rel={`noreferrer`}
        children={
          <img
            src={r}
            alt={
              t.campo.startsWith(`firma`)
                ? `Firma del acta`
                : `Evidencia ${t.campo.replace(`foto:`, ``)}`
            }
            className={`${n} w-full rounded-lg border border-(--border) object-cover`}
            onError={() => o(`No se pudo abrir la imagen`)}
          />
        }
      />
    ) : (
      <div className={`${n} animate-pulse rounded-lg bg-(--border)`} />
    )
  );
}
